var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalFullScreen",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "upgrade-modal-area" }, [
        _c("div", { staticClass: "info-icon" }, [_c("InfoIcon")], 1),
        _c("h3", [_vm._v("Upgrade Your Plan")]),
        _c("p", [
          _vm._v(
            " You’ve exceeded the amount of Managers you may invite with your current subscription plan. To keep inviting Managers to your team, please upgrade your subscription plan. "
          ),
        ]),
        _c(
          "div",
          { staticClass: "btns-wrap flex gap-2 justify-end" },
          [
            _c("UiButton", {
              attrs: { id: "Cancel", buttonText: "Cancel", variant: "outline" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
            _c("UiButton", {
              attrs: {
                buttonText: "View Subscriptions",
                id: "View Subscriptions",
                buttonClass: "bg-black",
              },
              on: {
                click: function ($event) {
                  return _vm.$router.push(`/profile/pricing`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }